import React from 'react';

interface ModalLayoutProps {
  header?: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
}

const ModalLayout = ({ header, content, footer }: ModalLayoutProps) => {
  return (
    <div className="d-flex flex-column" style={{ height: '100%' }}>
      {header}
      <div className="d-flex flex-column flex-grow-1">{content}</div>
      <div className="d-flex ant-row-space-between align-items-center">{footer}</div>
    </div>
  );
};

export default ModalLayout;
